import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

// Import CHUB Design System CSS
import './css/tailwind.css';
import './css/index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
